// extracted by mini-css-extract-plugin
export default {"root":"InputSearchBusiness_root__DXlVK","dropdown":"InputSearchBusiness_dropdown__g8MDI","item":"InputSearchBusiness_item__3QwI5"};